<template>
    <div id="home">
        <van-nav-bar z-index='1' fixed title="" left-text="缤纷精选" left-arrow @click-left="onClickLeft">
            <van-search disabled shape="round"  slot="right" @click="openSearch"/>
        </van-nav-bar>
        <div class="content">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for='(item,key) in bfIndexList.lunbolist' :key='key'><van-image :src="baseUrl.imgUrl+item.activityImg" @click="$router.push('/goodsDetail/'+item.productId)" /></van-swipe-item>
            </van-swipe>
            <div class="home-grid">
                <div class="home-grid-box" v-for="(item,key) in bfIndexList.classifylist" :key="key" @click="$router.push('/classify?classifyId='+item.classifyId)">
                    <img :src="baseUrl.imgUrl+item.classifyLogo" />
                    <span>{{item.classifyName}}</span>
                </div>
                <div class="home-grid-box" @click="$router.push('/classify')">
                    <img src="~img/index/allClassfy.png" />
                    <span>全部分类</span>
                </div>
            </div>
            <div class="labelImgBox" v-if="bfIndexList.shangxinlist.length!=0">
                <img class="labelImg" src="~img/home/newRecommendations.png" alt="">
                <p>为您优选 潮流新品</p>
                <img @click="labelMoreImgFn(1)" class="labelMoreImg" src="~img/home/viewMore.png" alt="">
            </div>
            <van-grid :column-num="3" class="newRecommendations">
                <van-grid-item v-for="(val,key) in bfIndexList.shangxinlist" :key="key">
                    <van-image :src="baseUrl.imgUrl+val.activityImg" @click="$router.push('/goodsDetail/'+val.productId)" />
                    <p class="pTitle">{{val.productName}}</p>
                    <div class="priceBox">
                        <span>￥{{val.productPreferentialPrice}}</span>
                        <img src="~img/home/add.png" alt="" @click="addFn(val.productId)">
                    </div>
                </van-grid-item>
            </van-grid>
            <div class="labelImgBox" style="margin-bottom:5px" v-if="bfIndexList.nowdayslist.length!=0">
                <img class="labelImg" src="~img/home/todayBig.png" alt="">
                <img style="top:0" @click="labelMoreImgFn(2)" class="labelMoreImg" src="~img/home/viewMore.png" alt="">
            </div>
            <div v-for="(item,index) in bfIndexList.nowdayslist" :key="index" style="margin-top:10px;">
                <img style="width:100%;border-radius:0.15rem;" :src="baseUrl.imgUrl+item.activityImg" alt="">
                <van-grid :column-num="3" class="newRecommendations">
                    <van-grid-item v-for="(val,key) in item.list" :key="key">
                        <van-image :src="baseUrl.imgUrl+val.productImage.split(',')[0]" @click="$router.push('/goodsDetail/'+val.productId)" />
                        <p class="pTitle">{{val.productName}}</p>
                        <div class="priceBox">
                            <span>￥{{val.productPreferentialPrice}}</span>
                            <img src="~img/home/add.png" alt="" @click="addFn(val.productId)">
                        </div>
                    </van-grid-item>
                </van-grid>
            </div>
            <div class="labelImgBox" style="margin-bottom:5px" v-if="bfIndexList.pinpailist.length!=0">
                <img class="labelImg" src="~img/home/brandAlliance.png" alt="">
            </div>
            <van-grid :border="false" :column-num="4" class="brandAlliance">
                <van-grid-item v-for="(val,key) in bfIndexList.pinpailist" :key="key" @click="linkExternal(val)">
                    <van-image :src="baseUrl.imgUrl+val.activityImg" />
                    <p class="pTitle">{{val.brandName}}</p>
                </van-grid-item>
            </van-grid>
        </div>
            <common-search ref="commonSearch"  :businessProperty="2"></common-search>
    </div>
</template>

<script>
import Scroll from '@/config/scroll';
import baseUrl from '@/config/baseUrl';
import { mapActions, mapState } from 'vuex';
import CommonSearch from '@/components/CommonSearch';
export default {
    name: 'Home',
    mixins: [Scroll],
    components: {
        CommonSearch
    },
    data() {
        return {
            baseUrl
        };
    },
    computed: {
        ...mapState('bfIndex', {
            bfIndexList: 'bfIndexList'
        })
    },
    methods: {
        ...mapActions('bfIndex', {
            getBfIndexList: 'getBfIndexListAction'
        }),
        ...mapActions('bfMerchantsShop', {
            shopCartModify: 'shopCartModifyAction'
        }),
        ...mapActions('shoppingCart', {
            getCartNum: 'getCartNumAction'
        }),
        onClickLeft(){
            this.$router.go(-1);
        },
        labelMoreImgFn(data){
            if(data === 1){
                this.$router.push('/classify');
            }else{
                this.$router.push('/zbIndex?businessProperty=2');
            }
        },
        addFn(data){
            this.shopCartModify({ productId: data, productNum: 1
            }).then((res) => {
                this.$toast.success('添加成功');
                //拉取购物车总数量
                this.getCartNum();
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        openSearch() {
            this.$refs.commonSearch.visible = true;
        },
        queryFn(){
            this.getBfIndexList({}).then((res) => {
                // console.log(res);
            });
        },
        linkExternal(val) {
            this.$router.push('/externalLink?href='+val.brandAddress+'&&title=品牌联盟');
        }
    },
    created() {
        this.queryFn();
    }
};
</script>
<style lang="scss">
    #home{
        .van-nav-bar{
            font-weight: bold;
            .van-icon{
                color: #000;
                font-size: 21px;
            }
            .van-search{
                background: bottom;
                width: 120px;
                position: relative;
                right: -10px;
                top: 3.5px;
                .van-icon{
                    color: #ccc;
                }
            }
        }
        .van-nav-bar__text{
            color: #000;
            font-size: 21px;
        }
        .content{
            padding: 8px;
            margin: 48px 0;
            .my-swipe{
                transform: translateZ(0);
                border-radius:5px;
                .van-image{
                    width: 100%;
                }
                img{
                    border-radius:5px;
                }
            }
            .home-grid{
                border-radius:5px;
                margin: 14px 0 0;
                width: 100%;
                overflow: hidden;
                background: #fff;
                .home-grid-box{
                    width: 15%;
                    padding: 4% 2.5% 0;
                    float: left;
                    text-align: center;
                    img{
                        width: 42px;
                        height: 42px;
                        display: block;
                        margin: 0 auto;
                    }
                    span{
                        display: block;
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(14,14,14,1);
                        line-height:30px;
                    }
                }
            }
            .brandAlliance{
                border-radius:5px;
                background: #fff;
                .van-grid-item__content{
                    background: bottom;
                }
                .van-image{
                    img{
                        border-radius: 5px;
                        height: 60px;
                    }
                }
                .pTitle{
                    width:100%;
                    height:20px;
                    margin-top: -8px;
                    background:rgba(254,254,254,1);
                    box-shadow:0px 0px 4px 0px rgba(160,160,160,0.13);
                    opacity:0.87;
                    border-radius:10px;
                    font-size:12px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(148,107,87,1);
                    line-height:20px;
                    text-align: center;
                }
            }
            .newRecommendations{
                border-radius:5px;
                background: #fff;
                .van-grid-item__content{
                    background: bottom;
                }
                .van-image{
                    img{
                        height: 86px;
                    }
                }
                .pTitle{
                    font-size:12px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(12,12,12,1);
                    line-height:16px;
                    margin: 5px 0;
                    text-align: left;
                    width: 100%;
                }
                .priceBox{
                    width: 100%;
                    overflow: hidden;
                    span{
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(232,91,77,1);
                        line-height:16px;
                        float: left;
                    }
                    img{
                        width:19px;
                        height:19px;
                        float: right;
                    }
                }
            }
            .labelImgBox{
                text-align: center;
                position: relative;
                margin-top: 12px;
                .labelImg{
                    width: 110px;
                    height: 20px;
                }
                p{
                    font-size:12px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(153,153,153,1);
                    line-height:26px;
                }
                .labelMoreImg{
                    width: 71px;
                    height: 17px;
                    position: absolute;
                    right: -8px;
                    top: 16px;
                }
            }
        }
    }
</style>
